import * as yup from "yup";

export const PaymentVoucherSetupValidationSchema = yup.object().shape({
  transactionType: yup
    .number()
    .nullable()
    .required("Transaction Type is required"),
  bankName: yup.string().required("Bank Name is required"),

  financialInstitutionNo: yup
    .string()
    .required("Financial Institution No is required"),

  bankTransitNo: yup.string().required("Bank Transit No is required"),

  bankAccountNo: yup.string().required("Bank Account No is required"),

  voucherDate: yup.date().required("Voucher Date is required"),
});
